import { render, staticRenderFns } from "./DottedBullet.vue?vue&type=template&id=4ec01f94&scoped=true&"
import script from "./DottedBullet.vue?vue&type=script&lang=js&"
export * from "./DottedBullet.vue?vue&type=script&lang=js&"
import style0 from "./DottedBullet.vue?vue&type=style&index=0&id=4ec01f94&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ec01f94",
  null
  
)

export default component.exports